// extracted by mini-css-extract-plugin
export default {"content":"styles_content__JeZ1p","wrapper":"styles_wrapper__X-JKz","fallback":"styles_fallback__clh3U"};